import type {
	JiraTimeFormat,
	JiraTimeUnit,
	aggBacklogDataQuery$data,
} from '@atlassian/jira-relay/src/__generated__/aggBacklogDataQuery.graphql';
import { TimeUnits, TimeFormats } from '@atlassian/jira-time-tracking-formatter/src/constants.tsx';
import type { TimeUnit, TimeFormat } from '@atlassian/jira-time-tracking-formatter/src/types.tsx';
import { BACKLOG, ENABLED } from '../../../../common/constants';

export const getJiraTimeUnit = (defaultUnit: JiraTimeUnit): TimeUnit => {
	switch (defaultUnit.toLowerCase()) {
		case TimeUnits.DAY: {
			return TimeUnits.DAY;
		}
		case TimeUnits.HOUR: {
			return TimeUnits.HOUR;
		}
		case TimeUnits.MINUTE: {
			return TimeUnits.MINUTE;
		}
		case TimeUnits.WEEK: {
			return TimeUnits.WEEK;
		}
		default: {
			return TimeUnits.DAY;
		}
	}
};

export const getJiraTimeFormat = (format: JiraTimeFormat): TimeFormat => {
	switch (format.toLowerCase()) {
		case TimeFormats.DAYS: {
			return TimeFormats.DAYS;
		}
		case TimeFormats.HOURS: {
			return TimeFormats.HOURS;
		}
		case TimeFormats.PRETTY: {
			return TimeFormats.PRETTY;
		}
		default: {
			return TimeFormats.DAYS;
		}
	}
};

export const isBacklogDisabledFromAggData = (aggData: aggBacklogDataQuery$data): boolean => {
	if (!aggData || !aggData.boardScope || !aggData.boardScope.features) {
		return true;
	}

	const filteredFeatures = aggData.boardScope.features.filter(Boolean);

	const backlogFeature = filteredFeatures.some(
		(feature) => String(feature.key) === BACKLOG && String(feature.status) === ENABLED,
	);
	return !backlogFeature;
};
